import {array, number, object, string} from 'yup';

import {paginationV8nSchema} from '@shared/api';
import {stringDefinedButCanBeEmpty} from '@shared/utils';
import {MarketplaceItemType} from '../types';

export const marketplaceItemV8nSchema = object().shape({
  id: string().required(),
  type: string().oneOf(Object.values(MarketplaceItemType)).required(),
  title: string().required(),
  description: stringDefinedButCanBeEmpty,
  price: number().nullable().defined(),
  image_url: string().required(),
});

export const v8nSchemaOfGetMarketplaceItemsResponse = paginationV8nSchema.shape(
  {
    array: array().of(marketplaceItemV8nSchema),
  },
);
